import { getIsUserVerifiedLocal } from '@interlayer/js/app/hooks/user/hooks/useIsUserVerified';

import {
    AUTH_SERVER_IDS,
    DEFAULT_STORE_REQUEST_TIME,
    MAX_TIMEOUT_TIMER,
    REQUEST_STATUSES } from './constants';
import { TServerSendRequest, TStoredRequest } from './types';

const requests: Map<string, TStoredRequest> = new Map();

export const getRequestKey = (request: TServerSendRequest) => JSON.stringify(request);
export const getRequest = (request: TServerSendRequest) => requests.get(getRequestKey(request));

export const checkIsUserVerified = (request: TServerSendRequest, isIgnoreUserVerified?: boolean) => {
    if (!isIgnoreUserVerified && getIsUserVerifiedLocal() === false && !AUTH_SERVER_IDS.includes(request.ID)) {
        return false;
    }

    return true;
};

export const removeRequest = (request: TServerSendRequest) => {
    requests.delete(getRequestKey(request));
};

export const registerRequest = (
    request: TServerSendRequest,
    isIgnoreUserVerified?: boolean
) => {
    const isRequestExist = getRequest(request);

    if (isRequestExist) {
        return isRequestExist;
    }

    const isUserVerified = checkIsUserVerified(request, isIgnoreUserVerified);
    const requestData: TStoredRequest = { request, storeTime: request.storeTime || DEFAULT_STORE_REQUEST_TIME };

    if (!isUserVerified) {
        requestData.promise = Promise.reject({ ID: request.ID, reason: 'User not verified' });
        requestData.status = REQUEST_STATUSES.notVerified;
        requestData.removeRequestTimer = setTimeout(() => {
            removeRequest(request);
        }, requestData.storeTime);
    }

    requests.set(getRequestKey(request), requestData);

    return getRequest(request);
};

export const updateRequest = (originalRequest: TServerSendRequest, status: REQUEST_STATUSES, data: Record<string, unknown>) => {
    const request = getRequest(originalRequest);
    const additionalData: TStoredRequest = {};

    if (!request) {
        return;
    }

    switch (status) {
        case REQUEST_STATUSES.pending:
        case REQUEST_STATUSES.timeout:
            clearTimeout(request?.removeRequestTimer);

            break;

        case REQUEST_STATUSES.failed:
            additionalData.attempts = request.attempts ? request.attempts + 1 : 1;
            // eslint-disable-next-line no-case-declarations
            const timeout = additionalData.attempts * 2 * 1000;
            additionalData.timeout = timeout < MAX_TIMEOUT_TIMER ? timeout : MAX_TIMEOUT_TIMER;

            clearTimeout(request?.removeRequestTimer);

            if (!request.isDontRemove) {
                additionalData.removeRequestTimer = setTimeout(() => {
                    removeRequest(originalRequest);
                }, additionalData.timeout * 1.5);
            }

            break;

        case REQUEST_STATUSES.success:
            additionalData.removeRequestTimer = setTimeout(() => {
                removeRequest(originalRequest);
            }, request.storeTime);

            break;

        case REQUEST_STATUSES.notStore:
        case REQUEST_STATUSES.withoutResponse:
            removeRequest(originalRequest);

            return;

        default:
            break;
    }

    requests.set(getRequestKey(originalRequest), {
        ...request,
        ...data,
        ...additionalData,
        status
    });
};
